import React from "react";
import Header2 from "../header2";
import HeaderStatic from "../headerStatic";
import { useLocation } from "react-router-dom";

export default function NavbarEvent(props) {
  const [scroll, setScroll] = React.useState(0);
  const { pathname } = useLocation();

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const className =
  //   scroll > 80 ? "fixed-navbar animated fadeInDown active" : "fixed-navbar";

  return (
    <div className="fixed-navbar animated fadeInDown active">
      <HeaderStatic
        Logo={props.Logo}
        topbarBlock={props.topbarBlock}
        hclass={props.hclass}
        isHome={pathname === "/" || pathname === "/home"}
      />
    </div>
  );
}
